// src/contexts/PWAContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';

const PWAContext = createContext(null);

export const PWAProvider = ({ children }) => {
    const [deferredPrompt, setDeferredPrompt] = useState(null);
    const [isInstallable, setIsInstallable] = useState(false);

    useEffect(() => {
        const handleBeforeInstallPrompt = (e) => {
            console.log('📥 Capturado evento beforeinstallprompt de PWA');
            // Prevenir el comportamiento por defecto (que el navegador muestre su aviso automático)
            e.preventDefault();
            // Almacenar el prompt diferido
            setDeferredPrompt(e);
            setIsInstallable(true);
        };

        const handleAppInstalled = (e) => {
            console.log('🎉 App instalada exitosamente por el usuario');
            setIsInstallable(false);
            setDeferredPrompt(null);
            // Registrar éxito en localStorage
            localStorage.setItem('pwa-installed', 'true');
        };

        // Agregar los listeners de eventos globales
        window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
        window.addEventListener('appinstalled', handleAppInstalled);

        // Limpiar los listeners
        return () => {
            window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
            window.removeEventListener('appinstalled', handleAppInstalled);
        };
    }, []);

    const resetInstallPrompt = () => {
        setDeferredPrompt(null);
        setIsInstallable(false);
    };

    return (
        <PWAContext.Provider value={{ deferredPrompt, isInstallable, resetInstallPrompt }}>
            {children}
        </PWAContext.Provider>
    );
};

export const usePWA = () => {
    const context = useContext(PWAContext);
    if (!context) {
        throw new Error('usePWA debe utilizarse dentro de un PWAProvider');
    }
    return context;
};
